import Navbar from "../../Landing/navbar/navbar";
import ProjectInfo from "../ProjectInfo/ProjectInfo";
import s from "./Ranking.module.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ALL_PROJECTS,
  UPCOMING_PROJECTS,
  COMMUNITY,
  HYPE,
  SAVE_LIKES,
  SORT_USER_LIKES,
} from "../../../Redux/actions/actions";
import { Link, useNavigate } from "react-router-dom";
import { gradientBorder, gradientColor } from "../../../helper/helper";
import InfoIcon from "@mui/icons-material/Info";
import AlertDialog from "../../Dialog/Dialog";
import Snackbar from "@mui/material/Snackbar";
import * as React from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Waveform } from "@uiball/loaders";
import SimpleDialog from "../../Login/dialogLogin/DialogLogin";

<Waveform size={40} lineWeight={3.5} speed={1} color="black" />;

export default function Projects({ colorFondo, setColorFondo }) {
  const [hypeInfo, setHypeInfo] = useState(false);
  const [sort, setSorted] = useState("hype");
  const [likeChanges, setLikedChanges] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);

  const dispatch = useDispatch();
  const topProjects = useSelector(
    (state) => state.clientReducer.mintedProjects
  );
  const likedProjects = useSelector(
    (state) => state.clientReducer.likedProjects
  );
  const user = useSelector((state) => state.clientReducer.user);
  let backgroundColor = gradientColor(colorFondo);
  let borderImage = gradientBorder(colorFondo);

  const hypeOpen = () => {
    setHypeInfo(!hypeInfo);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setLikedChanges(false);
  };

  const community = () => {
    dispatch(COMMUNITY("minted"));
    setSorted("community");
  };
  const handleHype = () => {
    dispatch(HYPE("minted"));
    setSorted("hype");
  };

  const handleUserLikes = () => {
    dispatch(SORT_USER_LIKES("user_likes"));
    setSorted("user_likes");
  };

  const save = () => {
    if (user.ok) {
      // console.log({ likedProjects })
      // console.log("esta logueado")
      // console.log(likedProjects)
      let body = {
        _id: user.id,
        projectsLiked: likedProjects,
      };
      dispatch(SAVE_LIKES(body));
    } else {
      setOpenLogin(true);
    }
    handleClose();
  };

  // console.log(topProjects)
  let firstFiveProjects = topProjects.slice(0, 5);
  let dmText =
    "Attention,%20soldier!%20I%20hereby%20request%20the%20enlistment%20of%20my%20project!🫡🪖";

  useEffect(() => {
    dispatch(ALL_PROJECTS());
    // dispatch(UPCOMING_PROJECTS())
  }, []);

  const action = (
    <React.Fragment style={{ backgroundColor: "red" }}>
      <Button color="success" size="small" onClick={() => save()}>
        Save
      </Button>
      <Button color="error" size="small" onClick={() => handleClose()}>
        Cancel
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => handleClose()}
      >
        <CloseIcon fontSize="small" onClick={() => handleClose()} />
      </IconButton>
    </React.Fragment>
  );

  return (
    <>
      <Navbar colorFondo={colorFondo} />
      <div className={s[colorFondo]}>
        <div className={s.tablaContainer}>
          <div className={s.btnTitle}>
            <div className={s.titleContainer}>
              <h3 className={s.titulo}>Top VENOM nfts</h3>
              <h4>
                Best 5 <span> NFT</span> projects in the <span>Venom</span>{" "}
                ecosystem
              </h4>
            </div>
            <div className={s.buttonContainer}>
              <div className={s.buttonDiv}><a style={backgroundColor} target="_blank" href={"https://twitter.com/messages/compose?recipient_id=1617597356001591325&text=" + dmText}
                class="twitter-dm-button" data-screen-name="@furni">
                List your Project</a>
              </div>
              <div className={s.buttonDiv}><Link to="/testnet" style={backgroundColor}>Testnet Projects</Link>
              </div>
            </div>
          </div>
          {/* <div onClick={()=> navigate("/allProjects")} className={s.grid}> */}
          {firstFiveProjects?.length ? (
            <div className={s.grid}>
              <div className={s.rows}>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span>Project</span>
                </div>
                <div>
                  <span
                    className={sort === "community" && s.underline}
                    onClick={() => community()}
                  >
                    community
                  </span>
                </div>
                <div className={s.hypeDiv}>
                  <span
                    className={sort === "hype" && s.underline}
                    onClick={() => handleHype()}
                  >
                    hype
                  </span>
                  <InfoIcon className={s.infoIcon} onClick={() => hypeOpen()} />
                </div>
                <div>
                  <span
                    className={sort === "user_likes" && s.underline}
                    onClick={() => handleUserLikes()}
                  >
                    Users Likes
                  </span>
                </div>
              </div>
              {firstFiveProjects?.map((project, index) => {
                return (
                  <ProjectInfo
                    setColorFondo={setColorFondo}
                    setOpenLogin={setOpenLogin}
                    openLogin={openLogin}
                    user={user}
                    likeChanges={likeChanges}
                    setLikedChanges={setLikedChanges}
                    likedProjects={likedProjects}
                    colorFondo={colorFondo}
                    altoUrl={project.altoUrl}
                    url={project.url}
                    key={project._id}
                    name={project.name}
                    twitterFollowers={project.twitterFollowers}
                    img={project.img}
                    id={project._id}
                    i={index}
                    minted={project.minted}
                    volumeToday={project.minted ? project.volumeToday : ""}
                    supply={project.minted ? project.supply : ""}
                    totalVolume={project.minted ? project.totalVolume : ""}
                    floorPrice={project.minted ? project.floorPrice : ""}
                    hype={project.hype}
                    userLikes={project.userLikes}
                  />
                );
              })}
            </div>
          ) : (
            <div style={{ paddingTop: "60px" }}>
              <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
            </div>
          )}
          {firstFiveProjects.length > 0 && (
            <>
              <Link to={"/allProjects"} style={borderImage} className={s.link}>
                Show More
              </Link>
              <AlertDialog hypeInfo={hypeInfo} hypeOpen={hypeOpen} />
            </>
          )}
          <Snackbar
            open={likeChanges}
            // autoHideDuration={6000}
            // onClose={()=> handleClose()}
            message="Save Changes"
            action={action}
          />
          <SimpleDialog onClose={() => setOpenLogin(false)} open={openLogin} />
        </div>
      </div>
    </>
  );
}
